import React, { Component } from 'react';
import { Link } from "react-router-dom";
import '../../css/Header.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export default class Header extends Component {

  constructor(props) {
      super(props);
      this.state = {
      }
  }

  render() {
/*

A DEV RECUP IMAGE HEADER CHECK PROPS ET SRC A DISTACNE POUR IMG

*/

// console.log(this.state,this.props);
// <img src={window.location.origin+"/"+this.props.datas[0].logo} alt="GHT de l'Artois" className="center" />

    return (
      <div className="header" >
          <div className="back">
              {window.location.pathname !== "/annuaire/" ?
                <Link to={{pathname:'/annuaire/' }} >
                <span className="icon is-large">
                  <FontAwesomeIcon className="fas fa-2x" icon="arrow-left" />
                </span>
                </Link> : ''}
          </div>
          <div className="logoght">
              <img src={'https://www.ght-artois.fr/'+this.props.datas[0].logo} alt="GHT de l'Artois" className="center" />
         </div>
      </div>
    );
  }
}